import React from "react";
import InfoWhite from "../../src/assets/info-white.png";
import useIsMobile from "../utils/useIsMobile";

export default function Wording() {
    const isMobile = useIsMobile();
    return (
        <div
            style={{
                background: "#FE8991",
                borderRadius: "10px",
                display: "flex",
                boxShadow: "rgba(0, 0, 0, 0.2) 0px 8px 5px",
                padding: "42px 10px",
                gap: "10px",
                // marginBottom: "1em",
                margin: isMobile ? "5px 10px 1em 10px" : "0 0 1em 0",
            }}
        >
            <div
                style={{
                    width: "40px",
                }}
            >
                <img
                    src={InfoWhite}
                    alt="info-white"
                    style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                    }}
                />
            </div>
            <h5
                style={{
                    margin: 0,
                    alignItems: "center",
                    lineHeight: 1.7,
                }}
            >
                Demi kenyamanan bersama, durasi konsultasi maksimal adalah{" "}
                <span style={{ fontWeight: 600 }}>20 menit</span>. Petugas berhak mengakhiri panggilan jika syarat dan ketentuan tidak
                dipatuhi.
            </h5>
        </div>
    );
}
